import { createTranslatingFormatter } from '@dreryk/react-common';

const translations = {
   pl: {
      medicineDatabasePharmindex: {
         integration: {
            endTime: 'Data zakończenia',
            startIntegration: 'Rozpocznij integrację',
            startTime: 'Data rozpoczęcia',
            status: 'Status',
            statusCode: {
               FAILED: 'Błąd',
               STARTED: 'Rozpoczęta',
               SUCCESS: 'Sukces',
               TERMINATED: 'Przerwana',
            },
            warnings: 'Ostrzeżenia',
         },
         pharmindexIntegration: 'Integracja z Pharmindex',
      },
   },
};

const integrationStatusFormatter = createTranslatingFormatter('medicineDatabasePharmindex:integration.statusCode.');

export { integrationStatusFormatter, translations };
